import VideoDurationAlertIcon from './VideoDurationAlertIcon';
export default VideoDurationAlertIcon;
